<section class="bg-white">
  <div class="mx-auto max-w-225 px-6 py-9">
    @if (loading()) {
      <p class="py-12 text-center text-[13.5px] text-(--text-muted)" aria-live="polite">{{ 'pages.newsDetail.loading' | translate }}</p>
    } @else if (notFound()) {
      <div class="py-12 text-center">
        <p class="m-0 mb-4 text-[15px] text-(--text-body)">
          {{ 'pages.newsDetail.notFound' | translate }}
        </p>
        <a routerLink="/news"
          class="inline-flex h-10 items-center rounded-sm border border-(--brand-primary) px-4 text-[13.5px] font-bold text-(--brand-primary) transition hover:bg-(--surface-primary-tint)">
          {{ 'pages.newsDetail.backToList' | translate }}
        </a>
      </div>
    } @else if (article(); as a) {
      <a routerLink="/news"
        class="mb-5 inline-flex items-center gap-1 text-[13px] font-bold text-(--brand-primary) hover:underline">
        ← {{ 'pages.newsDetail.allNews' | translate }}
      </a>

      <article appScrollReveal class="box-border overflow-hidden rounded-lg border border-(--border-subtle) bg-white shadow-(--shadow-card)">
        @if (imageUrl()) {
          <img [src]="imageUrl()" alt="" class="h-97 w-full object-cover" />
        }

        <div class="p-8">
          @if (a.publishedAt) {
            <div class="mb-3 text-[12.5px] text-(--text-muted)">{{ 'opportunities.detail.publishedOn' | translate }} {{ a.publishedAt | localizedDate }}</div>
          }
          <h1 class="m-0 text-[28px] font-extrabold leading-tight text-(--text-body)">{{ a.title }}</h1>
          @if (a.summary) {
            <p class="m-0 mt-3 text-[15px] leading-relaxed text-(--text-muted)">{{ a.summary }}</p>
          }

          <div class="my-6 h-px bg-(--border-subtle)" aria-hidden="true"></div>

          @if (a.body) {
            <p class="m-0 whitespace-pre-line text-[14.5px] leading-relaxed text-(--text-body)">{{ a.body }}</p>
          }

          @if (a.mediaGallery?.length) {
            <div class="my-6 h-px bg-(--border-subtle)" aria-hidden="true"></div>
            <app-media-gallery-carousel [assets]="a.mediaGallery!" />
          }
        </div>
      </article>
    }
  </div>
</section>
